const Utils = require('../Utils/Utils.js');

class Select2 {

    constructor($elt) {
        this.$view = $elt;
        this.init();
    }

    configureOptions() {
        let data_options = this.$view.data('options');

        const defaultOpions = {
            'select2' : {}
        };
        let defaultSelect2Options = {};
        const options = data_options ? JSON.parse(Utils.decode_html(data_options)) : {};

        if (options['footer_html']) {
            const uuid = Utils.uuid();
            defaultSelect2Options = {
                containerCssClass: 'container-' + uuid,
                dropdownCssClass: 'dropdown-' + uuid,
            };
        }
        
        this.options = {...defaultOpions, ...options};
        this.s2_options = {...defaultSelect2Options, ...this.options['select2']};


        // templating
        let mustacheTemplate = null;

        if (this.options['template_selector']) {
            const $template = $(this.options['template_selector']);
            if ($template.length === 0) {
                console.error("No template found with selector " + this.options['template_selector']);
            } else {
                mustacheTemplate = $template.html();
            }
        }

        if (this.options['template_html']) {
            mustacheTemplate = this.options['template_html'];
        }

        if (mustacheTemplate) {
            this.s2_options['templateResult'] = (state) => {
                if (!state.id) {
                    return state.text;
                }

                let mustacheData = state;

                // add data retrieve from vanilla option element
                if (state.element) {
                    mustacheData['data'] = $(state.element).data();
                    mustacheData['extra'] = mustacheData['data'];  // keep for legacy usage
                }
                return $('<span>' + mustache.render(mustacheTemplate, mustacheData) + '</span>');

            };
        }

        // ajax loading
        if (this.options['ajax_url']) {
            this.s2_options['ajax'] = {
                url: this.options['ajax_url'],
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {q: params.term, page: params.page}
                },
                processResults: function (data, params) {
                    let more = data.more || false;
                    return {
                        results: data.items,
                        pagination: {
                            more: more
                        }
                    }
                },
                cache: true
            }
        }
    }

    open() {
        this.$view.select2('open');
    }

    close() {
        this.$view.select2('close');
    }

    onOpen() {
        if (this.options['footer_html']) {
            const $dropdown = $('.' + this.s2_options['dropdownCssClass'] + ' .select2-results:not(.footer-rendered)');
            if ($dropdown) {
                $dropdown.addClass('footer-rendered')
                $dropdown.append('<div class="dropdown-footer">' + this.options['footer_html'] + '</div>');

                $dropdown.find('a').on('click', () => {
                    setTimeout(() => this.close(), 200);
                });
            }
        }
    }

    init() {
        this.configureOptions();
        this.$view.select2(this.s2_options).on('select2:open', () => {
                this.onOpen();
            });
        this.$view.show();
    }
}

module.exports = Select2;